import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ImportWarehouseHandlingDetailModal } from '../../models/warehose-handling-detail-modal';
import { LoggerService } from 'src/app/services/logger.service';
import { Router } from '@angular/router';
import { NumericService } from 'src/app/services/numeric.service';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { UserApiService } from '../../services/user-api.service';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { BarcodeService } from 'src/app/services/barcode.service';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { WarehouseHandlingModal } from '../../models/warehose-handling-modal';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { BarcodeScannerComponent } from '../../components/barcode-scanner/barcode-scanner.component';
import * as _ from 'lodash-es';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { SearchBoxComponent } from '../../components/search-box/search-box.component';
import { TabelPaging } from '../../interfaces/table';
import {
  digitsEnToFa,
  digitsFaToEn,
  digitsArToFa,
} from '@persian-tools/persian-tools';

declare var bootstrap: any;

@Component({
  selector: 'app-fast-warehouse-handling',
  templateUrl: './fast-warehouse-handling.component.html',
  styleUrl: './fast-warehouse-handling.component.css',
})
export class FastWarehouseHandlingComponent implements OnInit {
  constructor(
    private logger: LoggerService,
    public numericService: NumericService,
    private apiService: UserApiService,
    public calendarService: NewCalendarService,
    private responseService: CustomizeResponseService,
    private barcodeService: BarcodeService,
    private renderer: Renderer2
  ) {
    this.selectValue = new ImportWarehouseHandlingDetailModal(null);
    this.getSearchEntity();
    this.drugSearchForm = new FormGroup({
      drugBrandName: new FormControl(''),
    });

    this.searchRequestModel = new PCSearchRequestModel();
    this.searchRequestModel.pageSize = 20;

    this.renderer.listen('window', 'keyup', (e: any) => {
      if (e.key == 'Delete') {
        this.clearFullSelect();
      }
    });
  }

  @Input() selectValue: ImportWarehouseHandlingDetailModal;
  public cardClass: string = 'animate__backInDown';
  public alarmMessage: string = '';
  public searchBarcode: string | undefined;
  public endPoint: string = `WarehouseHandling`;
  public thisWarehouseHandling?: WarehouseHandlingModal;
  public modalLoading: boolean = false;
  public counterLevel: number = 1;
  public valueList: ImportWarehouseHandlingDetailModal[] = [];
  public barcode?: string;
  public activeMinus: boolean = false;
  public monthName: string = '';
  public modalSuccessConfirm: boolean = false;
  public pageLoaded: boolean = false;
  public modalIsOpen: boolean = false;

  @ViewChild('barcodeScanner') barcodeScanner!: BarcodeScannerComponent;
  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;

  @Output() outputParentAction = new EventEmitter<PCTableOutputModel>();

  collapseInstance: any;
  isCollapseShown = false;

  public searchDrugValue: string | undefined;
  public activeSearch: boolean = false;
  public searchRequestModel: PCSearchRequestModel;
  public searchData?: PCTableInputModel;
  @ViewChild(SearchBoxComponent)
  searchBoxComponent!: SearchBoxComponent;
  public drugSearchForm: FormGroup;
  public searchPaging?: TabelPaging;
  public searchFields: any[] = [];
  public activeAdd: boolean = false;
  public NewBarcode: any = {
    barCode: '',
    gtn: '',
    drugId: '',
  };

  public ngOnInit(): void {
    this.drugSearchForm
      .get('drugBrandName')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe((value) => {
        if (this.activeSearch) {
          this.searchDrug(value);
        } else {
          this.activeSearch = true;
        }
      });
  }

  public searchDrug(drugName: string): void {
    try {
      if (!drugName) {
        return;
      }

      if (this.modalIsOpen == false) {
        this.modalIsOpen = true;
      }
      let url = `BuyFactor/AdvanceSearch?pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}&search=${drugName}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.searchData = undefined;
      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          this.searchBoxComponent.InitPage();
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.searchRequestModel.pageNumber = 1;
            }

            this.searchData = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.searchRequestModel.orderBy,
              this.searchRequestModel.direction
            );

            this.searchPaging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.modalLoading = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.modalLoading = false;
    }
  }

  public parentSearchAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.modalLoading = true;
        if (this.searchRequestModel.orderBy == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.orderBy != event.data) {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == 'asd') {
          this.searchRequestModel.direction = 'desc';
        }

        this.searchRequestModel.orderBy = event.data;

        this.searchDrug(this.searchDrugValue!);
        break;
      case 'Paging':
        this.modalLoading = true;

        this.searchRequestModel.pageNumber = event.data;
        this.searchDrug(this.searchDrugValue!);
        break;
      case 'PageSize':
        this.modalLoading = true;
        this.searchRequestModel.pageSize = event.data;
        this.searchDrug(this.searchDrugValue!);
        break;
      case 'SelectItem':
        this.selectDrug(event);
        // this.selectDrug(event.data);
        // this.modalService.dismissAll();
        break;

      default:
        break;
    }
  }

  public saveBarcode() {
    try {
      if (
        (this.NewBarcode.barcode == null ||
          this.NewBarcode.barcode == '' ||
          this.NewBarcode.barcode.length < 4) &&
        (this.NewBarcode.gtn == null ||
          this.NewBarcode.gtn == '' ||
          this.NewBarcode.gtn.length < 4)
      ) {
        this.alarmMessage = 'Barcode_Null_Error';
        return;
      }

      if (this.NewBarcode.drugId == null || this.NewBarcode.drugId == '') {
        this.alarmMessage = 'Drug_Not_Select_Error';
        return;
      }

      const thisUrl = `DrugCode`;

      this.modalLoading = true;
      this.apiService
        .postItem(new ApiRequestModel(thisUrl, this.NewBarcode))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.modalSuccessConfirm = true;
              this.advanceSearch();
            } else {
              this.modalLoading = false;
            }
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.modalLoading = false;
          },
          () => {}
        );
    } catch (error) {
      this.logger.addError(error, false);
    }
  }

  public getSearchEntity() {
    this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          `DrugSearch`
        )
      )
      .subscribe(
        (result) => {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            result,
            `Get Entity`
          );
          if (result.succeeded) {
            this.searchFields = this.apiService.convertStringToBoolean(
              result.data.fields
            );

            this.searchFields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
  }

  public goToList(){
    this.outputParentAction.next(new PCTableOutputModel('WarehouseHandling', this.thisWarehouseHandling));
  }
  
  public advanceSearch() {
    try {
      if (this.searchBarcode == null) {
        this.openCamera();
        return;
      }
      this.alarmMessage = '';

      this.searchBarcode = digitsFaToEn(this.searchBarcode);
      const url = `${this.endPoint}/WarehouseHandlingDetail/Search/${this.thisWarehouseHandling?.stockId}?barCode=${this.searchBarcode}`;
      const expireDate = this.barcodeService.ToExpireDate(this.searchBarcode);
      if (expireDate != null) {
        this.selectValue.expireDate = expireDate;
      }

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        this.clearSelect();
        return;
      }

      this.modalLoading = true;
      this.counterLevel = 1;

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            switch (result.data.length) {
              case undefined:
                this.closeCollapseJS();
                this.openAddCollapseJS();
                this.clearSelect();
                this.alarmMessage = 'Barcode_Not_Found';
                this.activeAdd = true;
                break;
              case 0:
                this.closeCollapseJS();
                this.openAddCollapseJS();
                this.clearSelect();
                this.alarmMessage = 'Barcode_Not_Found';
                this.activeAdd = true;
                break;
              case 1:
                this.clearBarcode();
                this.activeAdd = false;
                this.selectValue = new ImportWarehouseHandlingDetailModal(
                  result.data[0]
                );
                if (expireDate != null) {
                  this.selectValue.expireDate = expireDate;
                }
                this.calcCounting(true);
                this.valueList = [];
                this.closeCollapseJS();
                
                break;
              default:
                this.clearBarcode();
                this.activeAdd = false;
                const inventory = result.data.filter(
                  (current) => current.expireDate != null
                );
                if (inventory.length == 1) {
                  this.selectValue = new ImportWarehouseHandlingDetailModal(
                    result.data[0]
                  );
                } else {
                  this.selectValue = new ImportWarehouseHandlingDetailModal(
                    null
                  );
                  if (expireDate != null) {
                    this.selectValue.expireDate = expireDate;
                  }
                }
                this.calcCounting(true);
                this.valueList = result.data;
                this.openCollapseJS();
                
                break;
            }
          } else {
            this.logger.addBackEndMessage(result);
            this.clearSelect();
          }
          this.barcode = undefined;
          this.modalLoading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.modalLoading = false;
          this.clearSelect();
        },
        () => {
          this.modalLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.modalLoading = false;
      this.clearSelect();
    }
  }

  private selectDrug(event) {
    const gtn = this.barcodeService.ToGTN(this.searchBarcode);
    if (gtn) {
      this.NewBarcode.gtn = gtn;
    } else {
      this.NewBarcode.barcode = this.searchBarcode;
    }
    this.NewBarcode.drugId = event.data.id;
    this.searchDrugValue = event.data.drugBrandPersianName;
    this.activeSearch = false;
  }

  private openCamera() {
    this.barcodeScanner.openPopup();
  }

  public clearSelect() {
    this.selectValue = new ImportWarehouseHandlingDetailModal(null);
    this.valueList = [];
    this.calcCounting(true);
    this.closeCollapseJS();
    this.alarmMessage = '';
  }

  public clearFullSelect() {
    this.clearBarcode();
    this.clearSelect();
  }

  public clearBarcode() {
    this.searchBarcode = undefined;
  }

  public closeCollapseJS() {
    const el2 = document.getElementById('newDrugCollapseSection');
    if (!el2) return;
    this.collapseInstance =
      this.collapseInstance || new bootstrap.Collapse(el2, { toggle: false });
    this.isCollapseShown = false;
    this.collapseInstance.hide();

    const el = document.getElementById('drugCollapseSection');
    if (!el) return;
    this.collapseInstance =
      this.collapseInstance || new bootstrap.Collapse(el, { toggle: false });
    this.isCollapseShown = false;
    this.collapseInstance.hide();
  }

  public openCollapseJS() {
    const el = document.getElementById('drugCollapseSection');
    if (!el) return;
    this.collapseInstance =
      this.collapseInstance || new bootstrap.Collapse(el, { toggle: false });
    this.isCollapseShown = true;
    this.collapseInstance.show();
  }
  
  public openAddCollapseJS() {
    const el = document.getElementById('newDrugCollapseSection');
    if (!el) return;
    this.collapseInstance =
      this.collapseInstance || new bootstrap.Collapse(el, { toggle: false });
    this.isCollapseShown = true;
    this.collapseInstance.show();
  }

  public calcCounting(changePackage: boolean) {
    if (this.selectValue == null) {
      return;
    }

    this.alarmMessage = '';
    if (changePackage) {
      if (
        this.selectValue.drugPackageCount == null ||
        this.selectValue.drugPackageCount.toString() == ''
      ) {
        this.selectValue.drugPackageCount = 1;
      }
      if (
        this.selectValue.countingDrugPackage == null ||
        this.selectValue.countingDrugPackage.toString() == ''
      ) {
        this.selectValue.countingDrugPackage = 0;
      }

      this.selectValue.countingWarehouseHandlingCount =
        this.selectValue.drugPackageCount *
        this.selectValue.countingDrugPackage;
    }

    if (this.activeMinus) {
      if (
        this.selectValue.countingFinalCount < this.selectValue.countingWarehouseHandlingCount
      ) {
        this.selectValue.countingWarehouseHandlingCount =
          this.selectValue.countingFinalCount;
        this.alarmMessage = 'countdown_greater_original';
      }
      this.selectValue.countingFinalCount =
        this.selectValue.warehouseHandlingCount -
        this.selectValue.countingWarehouseHandlingCount;
    } else {
      this.selectValue.countingFinalCount =
        this.selectValue.warehouseHandlingCount +
        this.selectValue.countingWarehouseHandlingCount;
    }
    if (this.selectValue.countingFinalCount < 0) {
      this.selectValue.countingAdjustment =
        this.selectValue.count + this.selectValue.countingFinalCount;
    } else {
      this.selectValue.countingAdjustment =
        this.selectValue.count - this.selectValue.countingFinalCount;
    }
  }

  public SetWithBarcode() {
    const barcode = this.selectValue!.expireDate;
    const expireDate = this.barcodeService.ToExpireDate(barcode);
    const lot = this.barcodeService.ToExpireDate(barcode);
    if (expireDate != null) {
      this.selectValue!.expireDate = expireDate;
    }
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public getRowClassName(drug: ImportWarehouseHandlingDetailModal): string {
    if (drug.inventoryDetailId == null) {
      if (this.selectValue.inventoryDetailId == null) {
        if (drug.drugId == this.selectValue.drugId) {
          return 'warning-row';
        }
      }
      return 'danger-row';
    } else {
      if (drug.inventoryDetailId == this.selectValue.inventoryDetailId) {
        return 'primary-row';
      } else {
        return 'success-row';
      }
    }
  }

  public selectAnotherDrug(drug: ImportWarehouseHandlingDetailModal) {
    const expireDate = _.cloneDeep(this.selectValue.expireDate);
    this.selectValue = _.cloneDeep(drug);
    if (expireDate != null) {
      this.selectValue.expireDate = _.cloneDeep(expireDate);
    }
    this.calcCounting(true);
  }

  public changeStatus() {
    this.activeMinus = !this.activeMinus;
    this.calcCounting(true);
  }

  public smartCount() {
    try {
      if (this.selectValue == null) {
        this.alarmMessage = 'WarehouseHandlingNotSelectError';
        return;
      }

      if (this.selectValue.countingWarehouseHandlingCount == null) {
        this.alarmMessage = 'WarehouseHandlingNotCountError';
        return;
      }

      if (this.selectValue.countingWarehouseHandlingCount == 0) {
        this.alarmMessage = 'countOfDrugsNotNegativeOnDrugError';
        return;
      }

      if (
        this.thisWarehouseHandling == null ||
        this.thisWarehouseHandling.id == null
      ) {
        this.alarmMessage = 'WarehouseHandlingNotFoundWarehouseIdError';
        return;
      }

      if (this.selectValue.expireDate == null) {
        this.alarmMessage = 'ExpireDateIsRequired';
        return;
      }

      let trueCountValue = this.selectValue.countingWarehouseHandlingCount;
      if (this.activeMinus) {
        trueCountValue *= -1;
      }

      const backEndJson = {
        count: trueCountValue,
        warehouseHandlingId: this.thisWarehouseHandling.id,
        inventoryDetailId: this.selectValue.inventoryDetailId,
        drugId: this.selectValue.drugId,
        sellPrice: this.selectValue.sellPrice,
        inventoryId: this.selectValue.inventoryId,
        ExpireDate: this.calendarService.ToGregorian(
          this.selectValue.expireDate
        ),
        stockId: this.thisWarehouseHandling?.stockId,
      };

      const thisUrl = `WarehouseHandling/WarehouseHandlingDetail/Submit`;

      this.modalLoading = true;
      this.apiService
        .postItem(new ApiRequestModel(thisUrl, backEndJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.modalSuccessConfirm = true;
              this.clearSelect();
              this.activeMinus = false;

              const barcodeInput = document.getElementById('drug-barcode');

              if (barcodeInput != null) {
                barcodeInput.focus();
              }
            } else {
            }
            this.modalLoading = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.modalLoading = false;
          },
          () => {}
        );
    } catch (error) {
      this.logger.addError(error, false);
    }
  }

  public LoadPage() {
    this.cardClass = 'animate__backInDown';
    this.pageLoaded = true;
    setTimeout(() => {
      this.cardClass = '';
    }, 2000);
  }

  public ClosePage() {
    this.cardClass = 'animate__backOutDown';
    setTimeout(() => {
      this.cardClass = '';
      this.pageLoaded = false;
    }, 1000);
  }

  public return() {
    this.outputParentAction.next(new PCTableOutputModel('Return', undefined));
  }

  public addBarcode() {}
}
